import {
  getVariantClassesDetail,
  getVariantClassesHeader,
} from '../../../../Common/FAQS/utils';
import { Accordion } from '../../../../Molecules/accordion';
import { Table } from '../../../../Ui';
import { IAccordionData } from '../../types';

export const render = (type: string, data: IAccordionData[], title: string) => {
  switch (type) {
    case 'accordion':
      return (
        <Accordion
          key={title}
          className={`calculator`}
          header={title}
          isExpandedState={false}
          detailPanelClasses={getVariantClassesDetail('calculator')}
          accordianHeaderEleClasses={getVariantClassesHeader('calculator')}
        >
          <div className="w-full">
            {data.map((item) => {
              return render(item.type, item.data, item.title || '');
            })}
          </div>
        </Accordion>
      );
    case 'table':
      return Object.entries(data).map(([key, value]) => {
        return (
          <div key={`${value.headers}_${key}`} className="overflow-scroll">
            <Table
              headers={value.headers}
              rows={value.rows}
              tableClass={['bg-[#D0E4FE] text-s-12 text-grey-900 border-0']}
            />
          </div>
        );
      });
    default:
      return <div>hello</div>;
  }
};

interface IYEAR_WISE_ACCORDION {
  section?: string;
  type?: string;
  data: IAccordionData[];
}

export const YearWiseAccordion = ({ data }: IYEAR_WISE_ACCORDION) => {
  return (
    <>
      {data.map((item) => {
        return render(item.type, item.data, item.title);
      })}
    </>
  );
};
